var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SourceValidationResult_1;
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { sourceValidationResultSchemaValidation } from '../../validations.generated';
export const sourceValidationResultSchema = {
    $id: 'urn:wisepipe-common-pipe:SourceValidationResult',
    type: 'object',
    properties: {
        isValid: { type: 'boolean' },
        comment: { type: 'string' },
        suggestedFix: { type: 'string' }
    },
    required: ['isValid']
};
/**
 * Represents the result of source validation.
 * @param {boolean} isValid - Specifies whether the source is valid (true) or not (false).
 * @param {string} [comment] - An optional comment describing the validation result. This is used to provide details about the validation issues to the AI.
 * @param {string} [suggestedFix] - An optional suggested fix for the validation issues. This is used to provide a fix for the AI to apply to the tool.
 */
let SourceValidationResult = SourceValidationResult_1 = class SourceValidationResult {
    constructor(isValid, comment, suggestedFix) {
        this.isValid = isValid;
        if (comment !== undefined)
            this.comment = comment;
        if (suggestedFix !== undefined)
            this.suggestedFix = suggestedFix;
        JSON.validate(this, SourceValidationResult_1);
    }
};
SourceValidationResult = SourceValidationResult_1 = __decorate([
    JsonSchemaV2(sourceValidationResultSchema, sourceValidationResultSchemaValidation)
], SourceValidationResult);
export { SourceValidationResult };
//# sourceMappingURL=sourceValidationResult.js.map